import { InjectionToken } from '@angular/core';
import { LoadingService } from '@selfai-platform/shared';

export const LOADING_ROUTES_LOAD = new InjectionToken<LoadingService>('LoadingRoutesLoad');